import React from 'react';
import { connect } from 'react-redux';
import io from 'socket.io-client';
import Api from '../utils/Api.jsx';

class Socket extends React.Component {

  constructor() {
    super();
    this.socket = null;
    this.backup = {};
    this.connectSocket();
  }

  connectSocket() {
    this.socket = io(global.app.urlApi);
    this.socket.on('connect', () => {
      this.dispatchSocket();
    });
    this.socket.on('inclusaoBackup', () => {
      this.backup = {};
      this.dispatchSocket();
    });
    this.socket.on('inclusaoEmpresa', async () => {
      console.log(this.props);
      
      const ret = await Api.getEmpresaUsuario(this.props.usuario, '');
      console.log(ret);
      
      this.props.dispatch({
        type: 'set_filiais',
        dados: ret.dados,
      });
    });
    this.socket.connect();
  }

  dispatchSocket() {
    this.props.dispatch({
      type: 'set_socket',
      backup: this.backup,
    });
  }
  
  render() {
    return null;
  }

}

export default connect((state) => ({
  usuario: state.usuario,
}), (dispatch) => ({
  dispatch,
}))(Socket);




// WEBPACK FOOTER //
// ./src/componentes/Socket.jsx